<app-header sectionName="Admin Panel">
  <button mat-flat-button (click)="openCreateUserDialog()">
    <mat-icon>add</mat-icon>
    Create User
  </button>
</app-header>

<main class="page">

  <!-- Filters -->
  <div class="list-toolbar">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Role</mat-label>
      <mat-select [(ngModel)]="filterRole" (ngModelChange)="onRoleChange()">
        <mat-option value="">All Roles</mat-option>
        @for (role of allRoles; track role) {
          <mat-option [value]="role">{{ role }}</mat-option>
        }
      </mat-select>
      <mat-icon matPrefix>manage_accounts</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-wide">
      <mat-label>Search</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="filterSearch" (ngModelChange)="onSearchChange()" placeholder="Username or name">
    </mat-form-field>

    @if (filterRole || filterSearch) {
    <button mat-button (click)="clearFilters()">
      <mat-icon>filter_alt_off</mat-icon>
      Clear filters
    </button>
    }
  </div>

  <div class="table-card">
    @if (loading && !users.length) {
      <div class="table-state">
        <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
        Loading users…
      </div>
    } @else {
      <div class="table-scroll">
      <table mat-table [dataSource]="users">

        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef>Username</th>
          <td mat-cell *matCellDef="let user" class="cell-username">
            <div class="user-cell">
              <span class="avatar">{{ user.username.charAt(0) }}</span>
              <span class="username">{{ user.username }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let user" data-label="Name">
            @if (user.name) {
              <button type="button" class="name-link" (click)="openSupplierInfoDialog(user)"
                      matTooltip="Show supplier info">{{ user.name }}</button>
            } @else {
              <span class="no-roles">—</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="roles">
          <th mat-header-cell *matHeaderCellDef>Roles</th>
          <td mat-cell *matCellDef="let user" data-label="Roles">
            <div class="roles-chips">
              @for (role of user.roles; track role) {
                <mat-chip [class]="getRoleClass(role)">{{ role }}</mat-chip>
              }
              @if (!user.roles || user.roles.length === 0) {
                <span class="no-roles">—</span>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let user" data-label="Status">
            <mat-chip [class]="user.active ? 'status-active' : 'status-blocked'">
              {{ user.active ? 'Active' : 'Blocked' }}
            </mat-chip>
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created At</th>
          <td mat-cell *matCellDef="let user" data-label="Created">{{ formatDate(user.created_at) }}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let user" class="cell-actions">
            <button mat-icon-button (click)="openEditUserDialog(user)" matTooltip="Edit username / password">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="openManageRolesDialog(user)" matTooltip="Manage roles" color="primary">
              <mat-icon>admin_panel_settings</mat-icon>
            </button>
            @if (isAdmin(user) && !isSuperAdmin(user)) {
              <button mat-icon-button (click)="openManagePermissionsDialog(user)" matTooltip="Permissions" color="primary">
                <mat-icon>lock_person</mat-icon>
              </button>
            }
            <button mat-icon-button (click)="toggleApiKey(user)" [matTooltip]="apiKeyTooltip(user)"
                    [color]="apiKeys.has(user.user_id) ? 'warn' : undefined">
              <mat-icon>{{ apiKeys.has(user.user_id) ? 'key_off' : 'vpn_key' }}</mat-icon>
            </button>
            @if (isSupplier(user) && user.active && !isSelf(user)) {
              <button mat-icon-button (click)="viewAsSupplier(user)" matTooltip="View supplier panel as this user" color="accent">
                <mat-icon>visibility</mat-icon>
              </button>
            }
            @if (!isSuperAdmin(user) && !isSelf(user)) {
              <button mat-icon-button (click)="toggleActiveStatus(user)"
                      [matTooltip]="user.active ? 'Block user' : 'Activate user'"
                      [color]="user.active ? 'warn' : 'primary'">
                <mat-icon>{{ user.active ? 'block' : 'check_circle' }}</mat-icon>
              </button>
            }
            @if (!isSuperAdmin(user) && !isSelf(user)) {
              <button mat-icon-button (click)="deleteUser(user)" matTooltip="Permanently delete (irreversible)" class="delete-btn" color="warn">
                <mat-icon>delete_forever</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      </div>

      @if (users.length === 0) {
        <div class="table-state">
          <mat-icon>people</mat-icon>
          No users match these filters.
        </div>
      }
    }

  <mat-paginator
    [length]="totalUsers"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [hidePageSize]="false"
    (page)="onPage($event)">
  </mat-paginator>
  </div>
</main>
